const ADMIN_PRODUCT = 'fulcrum/container/Admin/Product/Product'
const MOUNT = 'fulcrum/container/Admin/Product/Product/MOUNT'
const UNMOUNT = 'fulcrum/container/Admin/Product/Product/UNMOUNT'
const UPDATE_ACTIVE_DIALOG = 'fulcrum/container/Admin/Product/Product/UPDATE_ACTIVE_DIALOG'

const POST_PID_SYNC = 'fulcrum/container/Admin/Product/Product/POST_PID_SYNC'
const POST_PID_SYNC_START = 'fulcrum/container/Admin/Product/Product/POST_PID_SYNC_START'
const POST_PID_SYNC_SUCCESS = 'fulcrum/container/Admin/Product/Product/POST_PID_SYNC_SUCCESS'
const POST_PID_SYNC_ERROR = 'fulcrum/container/Admin/Product/Product/POST_PID_SYNC_ERROR'

export {
  ADMIN_PRODUCT,
  MOUNT,
  UNMOUNT,
  UPDATE_ACTIVE_DIALOG,
  POST_PID_SYNC,
  POST_PID_SYNC_START,
  POST_PID_SYNC_SUCCESS,
  POST_PID_SYNC_ERROR,
}
